import React from 'react'
import { useTranslation } from 'react-i18next';

function DiplomaProjectManagement() {
  const { t } = useTranslation();

  const what_will_you_get = [
    'Diploma Degree from Australia',
    'International Certification',
    'Possibility to get points for Australia Visa Application'
  ]

  const module_1 = [
    {
      title: 'Strategizing ESG P3 (Project, Program, Portfolio)',
      descriptions: [
        'Understand the relationship between ESG projects, programs, and portfolios in sustainable development.',
        'Develop a strategic approach to align ESG initiatives with broader business and sustainability objectives.',
        'Identify long-term sustainability goals and how to integrate them into organizational decision-making.'
      ]
    },
    {
      title: 'Governance System for ESG P3',
      descriptions: [
        'Establish corporate governance frameworks that ensure compliance with ESG regulations and ethical business practices.',
        'Define roles, responsibilities, and accountability structures within ESG project teams.',
        'Implement monitoring mechanisms to ensure transparency and adherence to ESG commitments.'
      ]
    },
    {
      title: 'Business Case Development for ESG P3',
      descriptions: [
        'Learn how to build a strong business case for ESG projects, showcasing their value.',
        'Conduct cost-benefit analysis to demonstrate financial, social, and environmental returns.',
        'Develop persuasive project proposals to secure funding and stakeholder support.'
      ]
    },
    {
      title: 'Developing ESG Projects Scope and Success Criteria',
      descriptions: [
        'Define clear project objectives, deliverables, and scope boundaries to prevent scope creep.',
        'Establish ESG-specific performance indicators to measure project success.',
        'Align project scope with global sustainability standards such as UN SDGs and ESG reporting frameworks.'
      ]
    },
    {
      title: 'Creating a Schedule for ESG Projects',
      descriptions: [
        'Use project management tools (e.g., Gantt charts, Agile, Critical Path Method) to create structured timelines.',
        'Define key milestones, deadlines, and dependencies for ESG projects.',
        'Balance resource availability with project deadlines to ensure efficiency.'
      ]
    },
    {
      title: 'Strategic Resource Planning for ESG Projects',
      descriptions: [
        'Identify financial, human, and material resources required for ESG initiatives.',
        'Optimize resource allocation to reduce environmental impact and maximize efficiency.',
        'Implement sustainable workforce planning, ensuring skills match project needs.'
      ]
    },
    {
      title: 'Developing a Budget for ESG Projects',
      descriptions: [
        'Learn cost estimation techniques for ESG-related activities.',
        'Identify funding sources, such as grants, green bonds, and sustainable investments.',
        'Implement budget control strategies to track expenditures and prevent overruns.'
      ]
    },
    {
      title: 'Stakeholder Analysis & Engagement Planning',
      descriptions: [
        'Identify key stakeholders (e.g., investors, regulators, communities, NGOs) and analyze their interests.',
        'Develop communication and engagement strategies tailored to different stakeholder groups.',
        'Foster collaboration and partnerships to enhance project success and stakeholder trust.'
      ]
    },
    {
      title: 'ESG P3 Risk Management',
      descriptions: [
        'Identify potential risks related to environmental impact, regulatory changes, and social concerns.',
        'Develop risk assessment and mitigation plans to minimize ESG-related challenges.',
        'Use proactive risk management techniques to anticipate and address sustainability concerns.'
      ]
    },
    {
      title: 'Quality Management',
      descriptions: [
        'Establish quality control measures to ensure ESG projects meet industry standards.',
        'Develop monitoring and evaluation systems for continuous project improvement.',
        'Ensure compliance with ESG certification requirements and best practices.'
      ]
    },
    {
      title: 'Information & Data Security Management',
      descriptions: [
        'Implement secure data management practices to protect sensitive ESG project information.',
        'Ensure compliance with international data protection regulations (e.g., GDPR, ISO 27001).',
        'Use blockchain and digital solutions to enhance transparency in ESG reporting.'
      ]
    },
    {
      title: 'Procurement Management',
      descriptions: [
        'Develop sustainable procurement strategies, focusing on ethical sourcing and green supply chains.',
        'Select suppliers that adhere to ESG principles and sustainability certifications.',
        'Monitor vendor performance and compliance with ESG procurement guidelines.'
      ]
    },
    {
      title: 'Integration Management',
      descriptions: [
        'Ensure all project components (scope, schedule, budget, risks, quality) work together seamlessly.',
        'Foster cross-functional collaboration between departments and stakeholders.',
        'Align project execution with corporate ESG objectives and sustainability strategies.'
      ]
    },
  ]

  return (
    <div>
      <section>
        <div className='relative'>
          <img src="https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/25708212d8c5e137294fe7ba0ad7baae4ce269c444086d80c0cdc85e602a4f8e5184556e4a039c3d9b54f528894634179c4925716df56a1400eb9db3ef2ebed69675bd481f55d5c33cec7892e2dd4b7f0d3025a58549e877d0a6b4d6afb885378ef627df505e501bc008c01cfca3a2046fd1ecd43c1afcacd8a4/rez-file-1739775349512.jpg" alt="main" className='w-full max-h-40 sm:max-h-80 object-cover object-bottom' />
          <div className='absolute top-0 bottom-0 left-0 right-0 bg-app-orange/10 text-white'>
            <div className='app-main-container flex flex-col justify-center items-center h-full gap-4 sm:gap-8'>
              <p className='text-xl/[2rem] sm:text-3xl/[4rem] lg:text-5xl/[5rem] px-8 font-semibold sm:font-bold text-center app-animation-translate-start'>Diploma of Project Management for ESG Projects with Australia Certification</p>
            </div>
          </div>
        </div>
      </section>

      <section className='bg-app-dark-gray/10'>
        <div className='app-main-container space-y-8'>
          <p className='py-3 md:py-6 text-base/[1.75rem] md:text-lg/[2rem] xl:text-xl/[2.5rem] text-base md:text-lg xl:text-xl text-center app-animation-translate-start'>
            <b>Diploma of Project Management for ESG Projects</b> is a specialized program designed for professionals who want to lead and manage projects with a strong focus on <b>Environmental, Social, and Governance (ESG) principles</b>. This course equips students with industry-relevant project management skills while integrating <b>sustainability and ethical governance</b> into real-world project execution.
          </p>
        </div>
      </section>

      <section className='bg-app-light-gray/10'>
        <div className='app-main-container space-y-4'>
          <p className='mt-4 mb-3 md:mt-8 md:mb-6 p-6 rounded-full bg-app-orange/80 text-xl md:text-2xl xl:text-3xl font-bold text-center app-animation-translate-start uppercase'>
            Module 1: <br /> Initiating & Planning Toolbox
          </p>
          <div className='app-main-container grid grid-cols-1 gap-10 md:gap-14 pt-2 pb-6 md:pt-4 md:pb-12'>
            {module_1.map((content, i) => {
              return (
                <div key={i} className='bg-app-dark-gray/10 space-y-4 p-4 sm:p-6 rounded-lg app-animation-translate-start'>
                  <div className='space-y-2 md:space-y-4  app-animation-translate-start'>
                    <p className='font-bold text-lg md:text-xl xl:text-2xl'>{i + 1}. {content.title}</p>
                  </div>
                  <ul className='ml-6 flex flex-col items-start text-base md:text-lg xl:text-xl space-y-2 md:space-y-4 font-medium app-animation-translate-start'>
                    {content.descriptions.map((description, k) => {
                      return (
                        <li key={k} className='px-2 list-disc'>
                          {description}
                        </li>
                      )
                    })}
                  </ul>
                </div>
              )
            })}
          </div>
        </div>
      </section>

      <section className='bg-app-dark-gray/10'>
        <div className='app-main-container space-y-4'>
          <p className='my-4  md:my-8 p-6 rounded-full bg-app-orange/80 text-xl md:text-2xl xl:text-3xl font-bold text-center app-animation-translate-start uppercase'>
            Module 2: <br /> Execution, Monitoring & Controlling
          </p>
        </div>
      </section>

      <section className='bg-app-light-gray/10'>
        <div className='app-main-container space-y-4'>
          <p className='my-4  md:my-8 p-6 rounded-full bg-app-orange/80 text-xl md:text-2xl xl:text-3xl font-bold text-center app-animation-translate-start uppercase'>
            Module 3: <br /> Closure & Handover
          </p>
        </div>
      </section>

      <section className='bg-app-dark-gray/10'>
        <div className='app-main-container space-y-4'>
          <p className='my-4  md:my-8 p-6 rounded-full bg-app-orange/80 text-xl md:text-2xl xl:text-3xl font-bold text-center app-animation-translate-start uppercase'>
            Module 4: <br /> Capstone Project & Computer Based Simulation
          </p>
        </div>
      </section>

      <section className='bg-app-light-gray/10'>
        <div className='app-main-container space-y-8'>
          <p className='pt-3 pb-2 md:pt-6 md:pb-4 text-xl md:text-2xl xl:text-4xl font-bold text-app-orange text-center app-animation-translate-start'>
            What Will You Get
          </p>
          <ul className='pt-2 py-8 ml-6 flex flex-col items-start text-lg md:text-xl xl:text-2xl space-y-2 md:space-y-4 app-animation-translate-start font-bold'>
            {what_will_you_get.map((item, i) => {
              return (
                <li key={i} className='px-2 list-disc'>
                  {item}
                </li>
              )
            })}
          </ul>
        </div>
      </section>

      <section className='bg-app-dark-gray/10'>
        <div className='app-main-container space-y-8'>
          <p className='pt-3 pb-2 md:pt-6 md:pb-4 text-xl md:text-2xl xl:text-4xl font-bold text-app-orange text-center app-animation-translate-start'>
            Delivery Methods
          </p>
          <img src="https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/8bb1725aefdbab968cd77c4cc5f36af4b76f9d80c074694ad7a7b0a407d422df90bdd63dd056f9e36841fdb9663f155051ea389323d978511e0762fd833e2ccd87383e7df3bfa465682b78fa15168773b4d42b2b752f868e4c9fd914b839822caef63ed894137c3d553a72ef2c5943b2774bb2262846c8142859/file-1739777249164.png" alt="main" className='pt-2 py-8 w-4/5 sm:w-3/5 mx-auto object-cover object-center app-animation-scale-start' />
        </div>
      </section>

      <section className='bg-app-light-gray/10'>
        <div className='app-main-container space-y-8'>
          <p className='pt-3 pb-2 md:pt-6 md:pb-4 text-xl md:text-2xl xl:text-4xl font-bold text-app-orange text-center app-animation-translate-start'>
            Professional Immersion Project
          </p>
          <img src="https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/df11b64e942f51fd9ef8b0aa22964042044978c5ed1287d81fcffc485e4206c610bb19240c195f43cd92bc430ca7ce02fd15bcde14e5d4991e2fd20850345c44c1e1fd3390a44775e524198b48c00eff0e76b4ec7f08b7925c61e1bceead7972a3d04cdf482150d4710379defdcaa3e1c0a0550ad520a3ae381f/file-1739777214676.png" alt="main" className='pt-2 py-8 w-4/5 sm:w-3/5 mx-auto object-cover object-center app-animation-scale-start' />
          <p className='pt-2 py-8 text-lg md:text-xl xl:text-2xl font-semibold text-app-orange text-center app-animation-translate-start'>
            Visit to Australia's Companies for 2 Days
          </p>
        </div>
      </section>
    </div>
  )
}

export default DiplomaProjectManagement